<template lang="html">
  <form-step
    :complete='complete'
    :step='step'
    :icon='icon'
    :title='title'
    v-model='valid'
    @submit='submit'>
    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field
          label='Name'
          v-model='payload.name'
          prepend-inner-icon='mdi-account'
          :rules='nameRules'/>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          label='Organization'
          v-model='payload.organization'
          prepend-inner-icon='mdi-domain'
          :rules='organizationRules'/>
      </v-flex>
      <v-flex xs12>
        <v-text-field
        label='Email'
        v-model='payload.email'
        type='email'
        prepend-inner-icon='mdi-email'
        :rules='emailRules'/>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          label='Number'
          v-model='payload.number'
          prepend-inner-icon='mdi-phone'
          mask='phone'
          :rules='numberRules'/>
      </v-flex>
      <v-flex xs12>
        <v-spacer></v-spacer>
        <v-btn
          type='submit'
          color='primary'
          :loading='loading'
          :disabled='disabled'>
          Continue
        </v-btn>
      </v-flex>
    </v-layout>
  </form-step>
</template>

<script>
import { mapActions } from 'vuex'
import FormStep from './FormStep'
export default {
  components: {
    'form-step': FormStep
  },
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    step: {
      type: [ Number, String ],
      default: 1
    },
    clear: Boolean
  },
  data: vm => ({
    payload: vm.createFreshForm(),
    loading: false,
    icon: 'mdi-account-card-details',
    title: 'Trip Planner Info',
    valid: true,
    nameRules: [ v => !!v || 'Name is required' ],
    emailRules: [ v => !!v || 'Email is required' ],
    numberRules: [ v => !!v || 'Phone Number is required' ],
    organizationRules: [ v => !!v || 'Organization is required' ]
  }),
  computed: {
    disabled () {
      return !this.valid || !!this.loading
    }
  },
  watch: {
    clear (val) {
      if(!!val) {
        this.payload = this.createFreshForm()
      }
    }
  },
  methods: {
    createFreshForm: () => ({
      name: null,
      organization: null,
      number: null,
      email: null
    }),
    submit() {
      this.loading = true
      return this.createPlanner(this.payload).then(() => {
        this.$emit('continue')
        this.payload = this.createFreshForm()
        this.loading = false
      }).catch(e => {
        this.raiseError(e)
        this.loading = false
      })
    },
    ...mapActions('plan', [ 'createPlanner' ]),
    ...mapActions('app', [ 'raiseError' ])
  }
}
</script>

<style lang="css" scoped>
</style>
